<template>
  <a-modal
    v-model="showModal"
    title="Approve Cashback Request"
    :footer="null"
    width="500px"
    :destroyOnClose="true"
    class="approve-cashback-modal"
  >
    <div class="mb-3">
      Please verify the participant and ensure all conditions are met before approving the cashback.
    </div>
    <a-row class="footer-viewscreen footer d-flex justify-content-end">
      <a-button
        type="danger"
        ghost
        :loading="loading"
        @click="cashbackRequest(false)"
      >
        Reject
      </a-button>
      <a-button
        type="danger"
        class="ml-2"
        :loading="loading"
        @click="cashbackRequest(true)"
      >
        Approve
      </a-button>
    </a-row>
  </a-modal>
</template>

<script>
import apiClient from '@/services/axios'
import { getErrorMessage } from '@/views/apps/fortune-wheel/composables/useGetErrorMessage.js'

const referralApiUrl = process.env.VUE_APP_REFERRAl_API_URL

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    validateItem: {
      type: Object,
      default: null,
    },
  },
  components: {
  },
  data: () => ({
    showModal: false,
    loading: false,
  }),
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.showModal = true
        } else {
          this.showModal = false
        }
      },
      deep: true,
      immediate: true,
    },
    showModal: {
      handler(val) {
        if (!val) {
          this.closeModal()
        }
      },
      deep: true,
    },
  },
  methods: {
    async cashbackRequest(status) {
      try {
        this.loading = true
        const programId = this.$route.params.id
        const cashbackId = this.validateItem.id

        const url = `${referralApiUrl}/referral-programs/${programId}/cashback/${cashbackId}/validate`
        const response = await apiClient.post(url, { is_approved: status })
        if (response?.status >= 200 && response?.status < 300) {
          this.$notification.success({
            message: status ? 'Cashback successfully approved' : 'Cashback successfully rejected',
          })
          this.$emit('updateTable')
          this.closeModal()
          return
        }
        getErrorMessage(response?.data)
      } catch (e) {
        this.$notification.error({
          message: e?.message ? e.message : 'Error',
        })
      } finally {
        this.loading = false
      }
    },
    closeModal() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.approve-cashback-modal {
  .footer {
    display: flex;
    justify-content: space-between;
    &::before,
    &::after {
      content: none;
    }
  }
}
</style>
